import inRange from 'lodash/inRange'

export const inHoursRange = (n: number, start: number, end: number) => {
  return inRange(n, start, end + 1)
}
